import { useAppActions } from 'reducers/slices/auth/updatePasswordSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { updatePassword } = useAppActions();
  const { passwordUpdatingStatus } = useSelector(state => state.authUpdatePasswordSlice);

  return {
    updatePassword,
    isPasswordUpdating: useFetchStatus(passwordUpdatingStatus).isPending,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/auth/useUpdatePassword.js